import React from 'react';
const LabeledContent = ({
  label,
  description,
  spanishDescription
}) => {
  return <>
      {description ? <div className="labeled-content-container">
          <div className="label">{label}</div>
          <div className="content">
            {description && <span className="label-content">{description}</span>}
            {spanishDescription && <span className="spanish-label-content">{spanishDescription}</span>}
          </div>
        </div> : null}
    </>;
};
export default LabeledContent;